var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardGame({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14,13c0-3.679-3.533-4.9-3.684-4.948a.991.991,0,0,0-.632,0C9.533,8.1,6,9.321,6,13c0,1.517.461,2.478,1.371,2.854A2.786,2.786,0,0,0,10,15.305a3.386,3.386,0,0,0,1.88.7,1.936,1.936,0,0,0,.749-.146C13.539,15.478,14,14.517,14,13Zm-2.126,1a2.282,2.282,0,0,1-1.167-.708,1,1,0,0,0-1.414,0,2.936,2.936,0,0,1-1.116.739S8,13.818,8,13a3.293,3.293,0,0,1,2-2.915A3.293,3.293,0,0,1,12,13,3.338,3.338,0,0,1,11.874,14ZM6,7A1,1,0,1,1,7,6,1,1,0,0,1,6,7Zm9,11a1,1,0,1,1-1-1A1,1,0,0,1,15,18ZM20,3H18.816A3,3,0,0,0,16,1H4A3,3,0,0,0,1,4V20a3,3,0,0,0,3,3H20a3,3,0,0,0,3-3V6A3,3,0,0,0,20,3ZM17,20a1,1,0,0,1-1,1H4a1,1,0,0,1-1-1V4A1,1,0,0,1,4,3H16a1,1,0,0,1,1,1Zm4,0a1,1,0,0,1-1,1H18.829c.322-.912.1-.875.171-16h1a1,1,0,0,1,1,1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardGame);
export default __webpack_public_path__ + "static/media/card-game.e52788dac3d0ac6dcbc6bf51dedbc570.svg";
export { ForwardRef as ReactComponent };